(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drawer-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeDrawer = (drawer) => {
      if (!drawer || drawer.dataset.pepleDrilldownReady === 'true') return;
      drawer.dataset.pepleDrilldownReady = 'true';

      const scrollContainer = drawer.querySelector('.peple-mobile-scroll');
      const panels = Array.from(drawer.querySelectorAll('[data-menu-panel]'));

      const showPanel = (panelId, moveFocus = true) => {
        const nextPanel = panels.find((panel) => panel.dataset.menuPanel === panelId);
        if (!nextPanel) return;

        panels.forEach((panel) => {
          const isActive = panel === nextPanel;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (scrollContainer) scrollContainer.scrollTop = 0;

        if (moveFocus) {
          const focusTarget = nextPanel.querySelector('.peple-mobile-back, .peple-mobile-menu-row, a');
          if (focusTarget) window.requestAnimationFrame(() => focusTarget.focus());
        }
      };

      drawer.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-menu-target]');
        if (trigger && drawer.contains(trigger)) {
          event.preventDefault();
          showPanel(trigger.dataset.menuTarget);
        }

        if (event.target.closest('.js-drawer-close')) {
          window.setTimeout(() => showPanel('menu-root', false), 250);
        }
      });
    };

    const initializeAll = () => {
      document.querySelectorAll('#NavDrawer.peple-mobile-drawer').forEach(initializeDrawer);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gwa-warranty"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gwa-warranty')) {
    customElements.define('gwa-warranty', class extends HTMLElement {
      connectedCallback() {
        if (this.warrantyReady) return;
        this.warrantyReady = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-warranty-open]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        trigger.addEventListener('click', event => {
          event.preventDefault();
          dialog.showModal();
        });
        this.querySelector('[data-warranty-close]').addEventListener('click', () => dialog.close());
        const zoom = this.querySelector('[data-warranty-zoom]');
        zoom.addEventListener('click', () => {
          const expanded = zoom.getAttribute('aria-pressed') !== 'true';
          zoom.setAttribute('aria-pressed', String(expanded));
          this.querySelector('.gwa-warranty__body').classList.toggle('is-zoomed', expanded);
        });
        dialog.addEventListener('click', event => {
          const bounds = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      }
      disconnectedCallback() {
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
